import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { AdminPageWrapper } from "../AdminPageWrapper";
import {
  Button,
  HStack,
  Icon,
  Link,
  SimpleGrid,
  Spacer,
  Stack,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { t } from "i18next";
import { AdminView } from "../../models/AdminView";
import { CreateApiClientModal } from "../../../account/views/integrations/CreateApiClientModal";
import { ApiClientItem } from "../../../account/views/integrations/ApiClientItem";
import { ManagePermissionsModal } from "./ManagePermissionsModal";
import { useStores } from "../../../shared/stores/RootStore";
import { AddIcon, ExternalLinkIcon } from "../../../shared/views/icons";
import { API_SPEC_URL } from "../../../../config";

const i18prefix = "account:Integrations";

const AdminIntegrationsPageBase: React.FC = () => {
  const { accountStore } = useStores();
  const createModal = useDisclosure();

  const initialLoad = async () => {
    accountStore.resetIntegrations();
    await accountStore.fetchAdminApiClients();
  };

  useEffect(() => {
    initialLoad();
    // eslint-disable-next-line
  }, []);

  return (
    <AdminPageWrapper selectedView={AdminView.Integrations}>
      <Stack px={6}>
        <Text fontSize="2xl">{t(`${i18prefix}.tab`)}</Text>

        <HStack>
          <Text>{t(`${i18prefix}.apiClients`)}</Text>
          <Button
            size="sm"
            variant="ghost"
            colorPalette="primary"
            onClick={() => {
              createModal.onOpen();
            }}
          >
            <AddIcon /> {t(`${i18prefix}.create`)}
          </Button>
          <Spacer />
          <Link
            color="primary.600"
            fontSize="sm"
            fontWeight="semibold"
            href={API_SPEC_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t(`${i18prefix}.specLink`)} <Icon as={ExternalLinkIcon} mx="2px" />
          </Link>
        </HStack>

        <SimpleGrid columns={{ lg: 1, xl: 2 }} gap={4}>
          {accountStore.apiClients.map((apiClient) => (
            <ApiClientItem
              key={apiClient.id}
              apiClient={apiClient}
              ManagePermissionsModal={ManagePermissionsModal}
            />
          ))}
        </SimpleGrid>
      </Stack>

      {createModal.open && (
        <CreateApiClientModal onClose={createModal.onClose} accountId={null} />
      )}
    </AdminPageWrapper>
  );
};

export const AdminIntegrationsPage = observer(AdminIntegrationsPageBase);
